<template>
    <div class="container">
        <div class="row pt-3 pb-3">
            <router-link to="/" class="dn col-10 col-lg-5 d-flex pr-0 pr-md-4">
                <img style="align-self: center;" src="../assets/ylc_logo.png" class="main-logo img-fluid pr-2" alt="The Lorna and Yuti Chernajovsky Biomedical Research Foundation logo">
                <div class="nav-link d-flex flex-column justify-content-center fs12 fs07">
                    <div>The Lorna & Yuti Chernajovsky</div>
                    <div>Biomedical Research Foundation</div>
                </div>
            </router-link>
            <div class="header-menu col-7 align-items-center fs12 d-none d-lg-flex">
                <router-link to="/about">About us</router-link>
                <router-link to="/grants">Grants</router-link>
                <router-link to="/impact">Impact</router-link>
                <router-link to="/contact">Contact</router-link>
            </div>
            <div class="col-2 d-flex align-items-center fs14 d-lg-none justify-content-end">
                 <i @click="toggleMenu" class="fas fa-bars text-blue"></i>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    methods:{
        toggleMenu(){
            this.$emit('changeMenu');
        }
    }
}
</script>

<style>
.header-menu{
    gap: 40px;
}
.nav-link{
    color: #2C3136;
}

</style>
